import React, { ChangeEvent } from "react";
import { Form } from "react-bootstrap";
import { WrappedFieldProps } from "redux-form";
import DateInput, { ReactDatePickerProps } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { assign } from "lodash";

interface CustomFieldProps {
  label: string;
  id: string;
  options: Array<{ text: string; value: string; key: string }>;
  placeholder: string;
  defaultValue?: string;
  required: boolean;
  isDisabled: boolean;
  isKeyBoardInput: boolean;
  handleOnBlur: (value: string) => void;
  yearChangeHandler?: (value: string) => void;
  monthChangeHandler?: (value: string) => void;
  changeHandler: (value: string) => void;
  onChangeRawHandler?: (element: ChangeEvent<HTMLInputElement>) => void;
  fieldError: boolean;
  icon?:string;
  pickerClassName?: string;
}

type CustomDatePickerProps = ReactDatePickerProps & WrappedFieldProps & CustomFieldProps;

const ReduxDatePicker = ({ yearChangeHandler, pickerClassName, monthChangeHandler, changeHandler, defaultValue, required, id, isDisabled, handleOnBlur, onChangeRawHandler, isKeyBoardInput, fieldError, meta: { touched, error }, label, placeholder, input: { name, value }, dateFormat, className, minDate, maxDate, readOnly,icon, ...restProps }: CustomDatePickerProps) => {
  const customInputs = assign(restProps, {
    selected: value ? new Date(value) : defaultValue ? new Date(defaultValue) : "",
    dateFormat: dateFormat ? dateFormat : "MM/dd/yyyy",
    placeholderText: placeholder ? placeholder : "MM/DD/YYYY",
    className: fieldError ? `${className ? className : ""} error is-invalid` : className ? className : "",
    minDate: minDate ?  new Date(minDate) : null,
    maxDate: maxDate ? new Date(maxDate) : null,
    onChange: (value: string) => changeHandler && changeHandler(value),
    onBlur: ({ target: { value } }: ChangeEvent<HTMLInputElement>) => handleOnBlur && handleOnBlur(value),
    onKeyDown: (event: ChangeEvent<HTMLInputElement>) => onChangeRawHandler(event),
    readOnly: readOnly ? readOnly : false,
    disabled: isDisabled,
    peekNextMonth: true,
    showMonthDropdown: true,
    showYearDropdown: true,
    preventOpenOnFocus: true,
    dropdownMode: "select",
    onMonthChange: (value: string) => monthChangeHandler && monthChangeHandler(value),
    onYearChange: (value: string) => yearChangeHandler && yearChangeHandler(value),
  });

  return (
    <Form.Group>
      {label && (
        <label className={`${fieldError ? "invalid-feedback block" : ""} block form-label`} htmlFor={id}>
          {required && label && <i aria-hidden="true" className="fas fa-asterisk"></i>}
          {label}
        </label>
      )}
      <div className={`${pickerClassName} datepickerDV`}>
        <div>
          <DateInput showYearDropdown={true} {...customInputs} id={id} disabled={isDisabled}/>
          <i className={`astm-icon far fa-calendar-alt ${icon}`}></i>
        </div>
      </div>
      {fieldError && (
        <div id="helpText" className="invalid-feedback block">
          {error}
        </div>
      )}
    </Form.Group>
  );
};

export default ReduxDatePicker;
